import { jsxs as c, jsx as r, Fragment as de } from "@emotion/react/jsx-runtime";
import { useId as he, useRef as pe, useState as fe, useImperativeHandle as me, useCallback as y, useEffect as ue } from "react";
import { useTheme as xe } from "@emotion/react";
import { CharacterCount as ge } from "../TextInput/subComponents/Count/Count.js";
import { Notice as ye } from "../TextInput/subComponents/Notice/Notice.js";
import { RightComponent as Ie } from "../TextInput/subComponents/RightComponent/RightComponent.js";
import { Wrapper as we, TextAreaContainer as Ce, StyledRelativeDiv as Re, TextAreaField as Te, TextAreaLabel as ke, ResetButton as ve } from "./TextArea.styled.js";
import { Icon as Ae } from "../Icon/index.js";
import { Stack as I } from "../Stack/index.js";
import { getColorNotice as De, NoticeContainer as He } from "../TextInput/TextInput.styled.js";
import { FontAwesomeIconsPartooUsed as Ee, IconPrefix as Ne } from "../../types/components/icon.js";
const We = ({
  dataTrackId: l,
  autoComplete: j = "on",
  autoFocus: L,
  cols: M,
  className: P,
  disabled: o = !1,
  edit: q,
  success: d,
  warning: w,
  error: i,
  customColor: C,
  generated: V,
  label: R,
  name: T,
  notice: k,
  characterCount: h,
  noTopLabel: B = !1,
  onBlur: p,
  onChange: v,
  onFocus: f,
  onKeyUp: U,
  onKeyDown: W,
  onReset: A,
  placeholder: X,
  readOnly: a = !1,
  required: _ = !1,
  rows: D = 3,
  maxRows: z = 5,
  tabIndex: G,
  unit: H,
  value: n,
  textareaProps: J,
  isReset: K = !1,
  hideInput: Q = !1,
  actionsContainer: Y,
  copy: E = !1,
  copyText: Z,
  copiedText: O,
  valueContainer: N,
  // Used only for multiselect to adjust position of searchText to bottom
  textAreaCss: ee,
  ref: te
}) => {
  const re = xe(), m = `textarea-${he()}`, t = pe(null), [u, $] = fe(!1), b = De({
    error: i,
    warning: w,
    success: d
  }), s = !!R && !B, x = s && (q || u || n || i || V), oe = !s || !!x, F = !!(d !== void 0 || H || E), ie = !!i || !!h || !!k;
  me(te, () => t, []);
  const ae = (e) => {
    e.preventDefault(), t.current && t.current.focus();
  }, ne = y((e) => v?.(e.target.value), [v]), se = y((e) => {
    !u && !a && $(!0), f && f(e);
  }, [u, a, f]), ce = y((e) => {
    !e.target.value && $(!1), p && p(e);
  }, [p]), le = (e) => {
    e.preventDefault(), A();
  };
  return ue(() => {
    if (!t.current)
      return;
    const e = Math.max(D, z), S = parseInt(re.typography.bodyMRegular.lineHeight.replace("px", "")), g = e * S;
    if (g && g < t.current.scrollHeight) {
      t.current.style.height = `${g}px`;
      return;
    }
    t.current.style.height = "auto", t.current.style.height = `${t.current.scrollHeight}px`;
  }, [n]), /* @__PURE__ */ c(we, { "data-track": l, "data-readonly": a, "data-disabled": o, className: P, children: [
    /* @__PURE__ */ c(Ce, { onClick: ae, "data-disabled": o, "data-readonly": a, "data-slate": C === "slate", "data-success": !!d, "data-warning": !!w, "data-error": !!i, children: [
      /* @__PURE__ */ r(Re, { children: /* @__PURE__ */ c(I, { gap: "8px", direction: "row", alignItems: "center", style: {
        position: "relative",
        width: "100%",
        padding: "12px 16px"
      }, children: [
        /* @__PURE__ */ c(I, { style: {
          position: "relative",
          width: "100%"
        }, children: [
          N && /* @__PURE__ */ r(de, { children: N }),
          !Q && /* @__PURE__ */ r(Te, { id: m, "aria-label": s ? void 0 : T ?? m, name: T, onReset: A, as: "textarea", autoComplete: j, autoFocus: L, cols: M, disabled: o, error: !!i, hasLabel: s, hasRightElement: F, isPlaceholderVisible: oe, onBlur: ce, onChange: ne, onFocus: se, onKeyUp: U, onKeyDown: W, placeholder: X, readOnly: a, ref: t, rows: D, tabIndex: G, value: n, edit: !!x, textAreaCss: ee, ...J }),
          s && /* @__PURE__ */ r(ke, { value: R, required: _, dataTrackId: `label_${l}`, edit: !!x, disabled: o, readOnly: a, color: C ?? b, htmlFor: m })
        ] }),
        !!n && K && /* @__PURE__ */ r(ve, { children: /* @__PURE__ */ r(Ae, { onMouseDown: le, dataTrackId: `reset-filters-${l}`, icon: [Ee.faCircleXmark, Ne.SOLID], color: "secondary" }) }),
        F && /* @__PURE__ */ r(Ie, { disabled: o, type: "textarea", value: n, unit: H, copy: E, copyText: Z, copiedText: O })
      ] }) }),
      Y
    ] }),
    /* @__PURE__ */ r(He, { opened: ie, children: /* @__PURE__ */ c(I, { direction: "row", justifyContent: "space-between", style: {
      padding: "4px 16px"
    }, children: [
      /* @__PURE__ */ r(ye, { color: b, children: k }),
      h && /* @__PURE__ */ r(ge, { value: n, hasError: !!i, disabled: o, characterCount: h })
    ] }) })
  ] });
};
export {
  We as TextArea
};
